import React from 'react'
import { ArrayField, SingleFieldList, ChipField, RaRecord } from 'react-admin'
import {
  LinkedOrganization,
  LinkedCustomerUser,
  TailoredProduct,
} from 'services/api/entities/catalog/types'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { WithId } from 'types/common'

type Props<T extends 'customersList' | 'organizationsList'> = {
  record?: RaRecord
  arrayFieldSource: T
  chipFieldSource: T extends 'customersList' ? 'email' : 'name'
  label: T extends 'customersList'
    ? 'form.fields.customers'
    : 'form.fields.organizations'
  tailoredListField: T extends 'customersList'
    ? 'customersFull'
    : 'organizationsFull'
}

type LinkedUserOrOrganizations = LinkedCustomerUser[] | LinkedOrganization[]

/**
 * if there is one tailored field returns it
 * else if there is more than one show the first with ...
 * else don't show anything
 */
const getTailoredList = (field: string, records: LinkedUserOrOrganizations) => {
  return records.length > 1
    ? [
        {
          [field]: records[0][field as keyof LinkedUserOrOrganizations[number]],
        },
        { [field]: '...' },
      ]
    : records.length
    ? [
        {
          [field]: records[0][field as keyof LinkedUserOrOrganizations[number]],
        },
      ]
    : []
}

const TailoredField = <T extends 'customersList' | 'organizationsList'>({
  chipFieldSource,
  label,
  arrayFieldSource,
  tailoredListField,
  record,
}: Props<T>) => {
  // FIXME: this is a bad workaround to enforce backwards compatibility, but we should handle it in a more solid way
  const recordFromContext = useKRecordContext<WithId & TailoredProduct>()

  const tailoredParsedRecord = {
    ...recordFromContext,
    [arrayFieldSource]: getTailoredList(
      chipFieldSource,
      recordFromContext?.[tailoredListField] ?? []
    ),
  }

  return (
    <ArrayField
      record={record ?? tailoredParsedRecord}
      source={arrayFieldSource}
      sortable={false}
      label={label}
    >
      <SingleFieldList>
        <ChipField source={chipFieldSource} />
      </SingleFieldList>
    </ArrayField>
  )
}

export default TailoredField
